import { useEffect, useState } from "react";
import axios from "axios";
import { listBlogs, normalizeBlog } from "../../../pages/Blog/blogApi";

const BLOG_LIMIT = 4; // one featured article + three smaller cards

/**
 * Articles for the landing page. Uses the blogs the admin marked for the home page
 * (POST /all/blogs/home); when none are marked it shows the newest published articles
 * (POST /all/blogs), so the section is not empty just because nothing was flagged.
 */
const useLatestBlogs = () => {
  const [state, setState] = useState({ status: "loading", blogs: [] });
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    let cancelled = false;
    setState({ status: "loading", blogs: [] });

    const load = async () => {
      const { data } = await axios.post(`${process.env.REACT_APP_BASE_URL}/all/blogs/home`, {
        page_number: 1,
        page_size: BLOG_LIMIT,
        order_by: "DESC",
      });
      if (data?.statusType !== "SUCCESS") throw new Error("Unexpected response");
      let blogs = (data.blogs || []).slice(0, BLOG_LIMIT).map(normalizeBlog);
      if (blogs.length === 0) {
        blogs = (await listBlogs({ page: 1, size: BLOG_LIMIT })).blogs;
      }
      return blogs;
    };

    load()
      .then((blogs) => {
        if (!cancelled) setState({ status: blogs.length ? "success" : "empty", blogs });
      })
      .catch(() => {
        if (!cancelled) setState({ status: "error", blogs: [] });
      });

    return () => {
      cancelled = true;
    };
  }, [attempt]);

  return { ...state, retry: () => setAttempt((n) => n + 1) };
};

export default useLatestBlogs;
